import type { JSX } from 'react';

import type { RecommendedGroupWithPlatform } from '../../../../hooks/useSharingTools/types';
import { RecommendedGroupCardItem } from '../RecommendedGroupCardItem';

import { mapRecommendedGroupToGroupData } from './helpers';

export function RecommendedGroupsCardsContainer({
	groups,
}: {
	groups: readonly RecommendedGroupWithPlatform[];
}): JSX.Element {
	return (
		<div className="flex h-full w-full items-center justify-center gap-2.5 md:gap-4">
			{groups.map(({ group, platform }) => {
				const groupData = mapRecommendedGroupToGroupData(group, platform);
				return <RecommendedGroupCardItem key={`${platform}-${group.url}`} group={groupData} platform={platform} />;
			})}
		</div>
	);
}
